import React, { useMemo, useState } from 'react';

export const BldgLocContext = React.createContext();

const BuildingLocationContext = (props) => {
    const [selectedLocation, setSelectedLocation] = useState();
    const [selectedBuildingIndex, setSelectedBuildingIndex] = useState();

    const requiredProps = useMemo(() => (
        { 
            chosenLocation: [selectedLocation, setSelectedLocation],
            chosenBuildingIndex: [selectedBuildingIndex, setSelectedBuildingIndex]
        }
    ), [selectedLocation, selectedBuildingIndex]);

    return (
        <BldgLocContext.Provider value={requiredProps}>
            {props.children}
        </BldgLocContext.Provider>
    );
};

export default BuildingLocationContext;